// extracted by mini-css-extract-plugin
export default {"subtitlesContainer":"subtitlesContainer__wsnMY","bottom":"bottom__7gy-p"};